import { render, staticRenderFns } from "./Expression.vue?vue&type=template&id=28f87d3c&scoped=true&"
import script from "./Expression.vue?vue&type=script&lang=js&"
export * from "./Expression.vue?vue&type=script&lang=js&"
import style0 from "./Expression.vue?vue&type=style&index=0&id=28f87d3c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f87d3c",
  null
  
)

component.options.__file = "Expression.vue"
export default component.exports